module.exports = __webpack_public_path__ + "img/deliver.c1041146.png";